// extracted by mini-css-extract-plugin
export default {"features":"features__features___2r_5j","feature":"features__feature___crJFI","iconImage":"features__iconImage___2Sa-r"};